import {useState} from "react";
import {ExperienceLevel} from "@betrue/shared/interfaces";
import {ExperienceView, ExperienceViewProps} from "./experience.view";


export const Experience = (props: ExperienceViewProps) => {

  const [experienceLevel, setExperienceLevel] = useState<ExperienceLevel>(props.level)

  let updateExperienceLevel = undefined
  if (props.onSelect) {
    updateExperienceLevel = (expLvl) => {
      props.onSelect(expLvl)
      setExperienceLevel(expLvl)
    }
  }


  return (<ExperienceView onSelect={updateExperienceLevel} level={experienceLevel}/>)
}
